import "@/App.css";
import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "@/site/ContentContext";
import { LightboxProvider } from "@/site/Lightbox";
import { Navbar } from "@/site/Navbar";
import { Seo } from "@/site/Seo";
import { Hero } from "@/site/Hero";
import { Ribbon } from "@/site/Ribbon";
import { Story } from "@/site/Story";
import { Cultura } from "@/site/Cultura";
import { Celebrate } from "@/site/Celebrate";
import { Gallery } from "@/site/Gallery";
import { Signatures } from "@/site/Signatures";
import { MenuSection } from "@/site/MenuSection";
import { HappyHour } from "@/site/HappyHour";
import { Testimonials } from "@/site/Testimonials";
import { Visit } from "@/site/Visit";
import { Footer } from "@/site/Footer";
import FullMenu from "@/site/FullMenu";
import Drinks from "@/site/Drinks";
import Admin from "@/site/Admin";
import { Preloader } from "@/site/Preloader";
import { OrderFab } from "@/site/OrderFab";
import { PopupAds } from "@/site/PopupAds";
import { ThemeInjector } from "@/site/ThemeInjector";

function SiteChrome() {
  const { pathname } = useLocation();
  if (pathname === "/admin") return null;
  return (
    <>
      <OrderFab />
      <PopupAds />
    </>
  );
}

function Home() {
  const location = useLocation();
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const el = document.querySelector(target);
      setTimeout(() => el?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [location]);

  return (
    <div className="relative bg-cantina-cream" data-testid="app-root">
      <Seo page="home" path="/" />
      <Navbar />
      <main>
        <Hero />
        <Ribbon />
        <Story />
        <Cultura />
        <Signatures />
        <MenuSection />
        <HappyHour variant="home" />
        <Celebrate />
        <Gallery />
        <Testimonials />
        <Visit />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ContentProvider>
          <ThemeInjector />
          <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
            <LightboxProvider>
              <Toaster position="top-center" richColors />
              <Preloader />
              <div className="App">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/menu" element={<FullMenu />} />
                  <Route path="/drinks" element={<Drinks />} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </div>
              <SiteChrome />
            </LightboxProvider>
          </ReactLenis>
        </ContentProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
